"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.catchAndNoticeError = exports.noticeErrorFromException = exports.noticeError = void 0;
const browser_rum_1 = require("@datadog/browser-rum");
/**
 * Log an error. This will send to our app monitoring tool AND print in Console.
 * In this context, an error is something that you need to actually fix.
 * @param {String} message
 * @param {*} attributes
 * @param {Function} logger A logging function to use other than console.error
 */
const noticeError = (message, attributes, logger, logToDataDog) => {
  try {
    // @todo add DD
  } catch (e) {
    console.error(e);
  }
  try {
    if (logger && typeof logger === 'function') {
      logger(message, attributes ?? {});
    } else if (console && console.error) {
      console.error(message, attributes);
    }
    if (logToDataDog) {
      browser_rum_1.datadogRum.addError(new Error(message), attributes ?? {});
    }
  } catch (e) {
    if (console && console.error) {
      console.error(message, attributes);
    }
  }
};
exports.noticeError = noticeError;
/**
 * Helper function to handle an JS exception. Calls `noticeError`.
 * @param {Error} e
 */
const noticeErrorFromException = function (e) {
  let logger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  const {
    name,
    message,
    stack
  } = e;
  noticeError(e.message, {
    name,
    message,
    stack
  }, logger, false);
  browser_rum_1.datadogRum.addError(e);
};
exports.noticeErrorFromException = noticeErrorFromException;
/**
 * Helper function to wrap a function in a try-catch that uses `noticeErrorFromException`.
 * @param {Function} functionToExecute
 */
const catchAndNoticeError = functionToExecute => {
  try {
    return functionToExecute();
  } catch (e) {
    noticeErrorFromException(e);
  }
  return null;
};
exports.catchAndNoticeError = catchAndNoticeError;